import gql from 'graphql-tag';

export const GET_SERVICE_REQUEST_EDITOR = gql`
	query GetServiceRequestEditor($id: String!) {
		serviceRequest(id: $id) {
			id
			status
			editor {
				id
				name
				image
				phoneNumber
				email
			}
			service {
				id
				property {
					id
				}
			}
		}
	}
`;

export const GET_SERVICE_REQUEST_ADDRESS = gql`
	query PropertyAddressForEditor($id: String!) {
		property(id: $id) {
			id
			address
		}
	}
`;
